export default __webpack_public_path__ + "static/media/Chinkara Deer.77416156.jpg";